// test1892
(1892 && 0);
